import { ReactComponent as RenewalIconSVG } from '@/assets/icons/New-Renewal.svg';
import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export const RenewalIcon = ({ bgColor = '#F5E4CB', width='24px', height='24px', ...props }) => {
	const { color } = props;
    
	return (
		<SvgIcon
			{...props}
			sx={{
				backgroundColor: bgColor, 
				width: width,
				height: height,
				borderRadius: 2,
				'& path': { fill: color },
			}}
		>
			<RenewalIconSVG />
		</SvgIcon>
	);
};
